import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// import { useLocation } from "react-router-dom";
import { api } from "../utils/authActions";
import { hasProperty } from "../utils/helpers";
import "./confirmEmail.scss";
import { GeneralContext } from "../context/GeneralContext";

function ConfirmEmail() {
  const { recordedErrorLog } = useContext(GeneralContext);
  let query = new URLSearchParams(useLocation().search);
  const token = query.get("token");
  const [text, setText] = useState("Email Confirmation Page");
  const navigate = useNavigate();

  useEffect(() => {
    if (token !== null && token !== undefined) {
      // users: create account for user
      api
        .confirmEmail(token)
        .then(() => {
          setText("Email confirmation successful! Redirecting ...");
          setTimeout(() => {
            navigate("/login");
          }, 3000);
        })
        .catch((err) => {
          const errorDetails = hasProperty(err, "response")
            ? `Backend response: ${JSON.stringify(err.response, null, 2)}`
            : "No backend response available";
          if (
            hasProperty(err, "response") &&
            hasProperty(err.response, "status") &&
            err.response.status === 409
          ) {
            setText(
              `Email confirmation unsuccessful. ${err.response.data.detail}`
            );
          } else {
            setText("Email confirmation unsuccessful! Please contact support.");
            recordedErrorLog(
              `THERE WAS AN ERROR WITH EMAIL CONFIRMATION: ${errorDetails}`,
              err,
              false,
              ""
            ); // no toats needed, but email should be sent
          }
        });
    }
  }, []);

  return (
    <div className="confirmEmailPage">
      <div className="text">{text}</div>
    </div>
  );
}

export default ConfirmEmail;
